module.exports = __webpack_public_path__ + "res/logo_showcase.c630c0e120dbdecbbe247fe7ff71b84b.png";